import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import {
    CdnClientUrl,
    navigateToExternalLink,
} from '@deltek/specification-client/core/Utilities/urlUtils'
import { GridSize, Typography } from '@material-ui/core'
import Link from '@material-ui/core/Link'
import { Theme, makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { useCallback } from 'react'
const useStyles = makeStyles((theme: Theme) => ({
    fullWidth: {
        width: '100%',
    },
    itemLeftSide: { width: 30 },
    itemRightSide: {
        width: 'calc(100% - 30px)',
        paddingLeft: theme.spacing(1),
    },
    icon: {
        height: 30,
        width: 30,
        mixBlendMode: 'multiply',
    },
    iconFull: {
        height: 30,
        mixBlendMode: 'multiply',
    },
    itemLabel: {
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    tableBorder: {
        '& .MuiTableCell-sizeSmall:last-child': {
            paddingLeft: 0,
            paddingTop: theme.spacing(1.25),
            paddingBottom: theme.spacing(1.25),
        },
    },
    itemLink: {
        maxWidth: 470,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            cursor: 'pointer',
        },
        fontSize: pxToRem(14),
        color: '#A78966',
    },
    itemLinksInner: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
}))

export interface ViewPartnershipTypeProps {
    xs: GridSize
    label: string
    link?: string
    level?: ListingLevel
}
export enum ListingLevel {
    PremiumMasterSpec = 'Premium MasterSpec',
    Premium = 'Premium',
    PremiumProprietary = 'Premium Proprietary',
    Manufacturer = 'Manufacturer',
    ProductListing = 'Product Listing',
    Product = 'Product',
    None = 'None',
}
const ViewPartnershipType: React.FC<ViewPartnershipTypeProps> = ({
    xs,
    label,
    link,
    level,
}) => {
    const classes = useStyles()
    const handleKeyDown = useCallback(
        (e) => {
            if (e.key === 'Enter' || e.code === 'Enter') {
                navigateToExternalLink(link!)
            }
        },
        [navigateToExternalLink]
    )
    if (link) {
        return (
            <Link
                data-testid="navigationLink"
                onClick={() => navigateToExternalLink(link)}
                className={classes.itemLinksInner}
            >
                {label === 'Swatchbox' ? (
                    <img
                        src={`${CdnClientUrl}/${label}_Full.png`}
                        className={clsx(
                            'partnershipType',
                            classes.iconFull,
                            classes.itemLink
                        )}
                        alt={label.toLowerCase().slice(0, 2)}
                        onClick={() => navigateToExternalLink(link!)}
                        onKeyDown={handleKeyDown}
                        role="button"
                        tabIndex={0}
                    />
                ) : (
                    <>
                        <img
                            src={`${CdnClientUrl}/${label}.png`}
                            className={classes.icon}
                            alt={label.toLowerCase().slice(0, 2)}
                        />
                        &nbsp;&nbsp;
                        {label === 'BIMsmith' &&
                        level === ListingLevel.PremiumProprietary ? (
                            <Typography
                                variant="body1"
                                className={classes.itemLink}
                            >
                                {label}
                            </Typography>
                        ) : (
                            <Link
                                onClick={() => navigateToExternalLink(link!)}
                                onKeyDown={handleKeyDown}
                                role="button"
                                tabIndex={0}
                            >
                                <Typography
                                    variant="h6"
                                    className={clsx(
                                        'partnershipType',
                                        classes.itemLabel,
                                        classes.itemLink
                                    )}
                                >
                                    {label}
                                </Typography>
                            </Link>
                        )}
                    </>
                )}
            </Link>
        )
    }
    return null
}

export default ViewPartnershipType
